import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MessageSquare, ArrowRight, Inbox } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function MessagesPage() {
  const { isAdmin } = useAuth();
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConversations();
  }, []);

  const fetchConversations = async () => {
    try {
      // Use the new smart messaging endpoint that only returns quotes with messages
      const response = await axios.get(`${API_URL}/conversations`);
      setConversations(response.data);
    } catch (error) {
      console.error('Erreur lors du chargement des conversations:', error);
    } finally {
      setLoading(false);
    }
  };

  const basePath = isAdmin ? '/admin/devis' : '/dashboard/devis';

  return (
    <div className="space-y-6" data-testid="messages-page">
      <div>
        <h1 className="text-2xl font-bold text-white">Messages</h1>
        <p className="text-white/50 mt-1">
          Consultez et répondez aux messages liés à vos devis
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
        </div>
      ) : conversations.length === 0 ? (
        <div className="card-dashboard text-center py-16">
          <Inbox className="w-16 h-16 text-white/10 mx-auto mb-4" />
          <p className="text-white/50 text-lg">Pas de messages</p>
          <p className="text-white/30 text-sm mt-2">
            Vous n'avez aucune conversation active pour le moment
          </p>
        </div>
      ) : (
        <div className="grid gap-4">
          {conversations.map((quote, index) => (
            <motion.div
              key={quote.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
            >
              <Link
                to={`${basePath}/${quote.id}`}
                className="card-dashboard flex items-center justify-between hover:border-[#D4AF37]/50 transition-colors group"
                data-testid={`conversation-${quote.id}`}
              >
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/10 border border-[#D4AF37]/20">
                    <MessageSquare className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                  <div>
                    <p className="text-white font-medium">{quote.quote_number}</p>
                    <p className="text-white/50 text-sm">{quote.client_info?.name}</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <span className={`status-${quote.status} px-3 py-1 text-xs uppercase tracking-wider`}>
                    {quote.status}
                  </span>
                  <ArrowRight className="w-5 h-5 text-white/30 group-hover:text-[#D4AF37] group-hover:translate-x-1 transition-all" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
